import { IntlShape } from 'react-intl';
import { EventBusinessLinesValues, EventRegionsValues, EventTypesValues, IEventBusinessLines, IEventRegions, IEventTypes } from '../api/events.dao';
import { EventLinksValues, IEventLinks } from '../api/events.dao';

export const createEventText = {
    id: `oe.event.newEvent`,
    description: 'Label text',
    defaultMessage: '{prefix}New Event',
};

export const createBookEventText = {
    id: `oe.event.newBooking`,
    description: 'Label text',
    defaultMessage: '{prefix}New Booking',
};

export const clientDepartmentText = {
    id: 'oe.event.clientDepartment',
    description: 'Label text',
    defaultMessage: 'Client Department'
};

export const noClientDepartmentText = {
    id: `oe.event.noClientDepartmentSelected`,
    description: 'Label text',
    defaultMessage: 'No Client Department Selected',
};

const eventTypes = (intl: IntlShape): IEventTypes[] => [
    {
        value: EventTypesValues.AGM,
        label: intl.formatMessage({
            id: `oe.eventType.AGM`,
            description: 'Label text',
            defaultMessage: 'AGM',
        })
    },
    {
        value: EventTypesValues.ANALYST_MARKETING,
        label: intl.formatMessage({
            id: `oe.eventType.ANALYST_MARKETING`,
            description: 'Label text',
            defaultMessage: 'Analyst Marketing',
        })
    },
    {
        value: EventTypesValues.BUSINESS_MEETINGS,
        label: intl.formatMessage({
            id: `oe.eventType.BUSINESS_MEETINGS`,
            description: 'Label text',
            defaultMessage: 'Business Meetings',
        })
    },
    {
        value: EventTypesValues.CONFERENCE,
        label: intl.formatMessage({
            id: `oe.eventType.CONFERENCE`,
            description: 'Label text',
            defaultMessage: 'Conference',
        })
    },
    {
        value: EventTypesValues.DAY_OF_COMMS_LINE,
        label: intl.formatMessage({
            id: `oe.eventType.DAY_OF_COMMS_LINE`,
            description: 'Label text',
            defaultMessage: 'Day of Comms Line',
        })
    },
    {
        value: EventTypesValues.DEAL_ROADSHOW,
        label: intl.formatMessage({
            id: `oe.eventType.DEAL_ROADSHOW`,
            description: 'Label text',
            defaultMessage: 'Deal Roadshow',
        })
    },
    {
        value: EventTypesValues.EARNINGS_RELEASE,
        label: intl.formatMessage({
            id: `oe.eventType.EARNINGS_RELEASE`,
            description: 'Label text',
            defaultMessage: 'Earnings Release',
        })
    },
    {
        value: EventTypesValues.EDUCATION_TRAINING,
        label: intl.formatMessage({
            id: `oe.eventType.EDUCATION_TRAINING`,
            description: 'Label text',
            defaultMessage: 'Education / Training',
        })
    },
    {
        value: EventTypesValues.EXPERT_EVENT,
        label: intl.formatMessage({
            id: `oe.eventType.EXPERT_EVENT`,
            description: 'Label text',
            defaultMessage: 'Expert Event',
        })
    },
    {
        value: EventTypesValues.FIELD_TRIP,
        label: intl.formatMessage({
            id: `oe.eventType.FIELD_TRIP`,
            description: 'Label text',
            defaultMessage: 'Field Trip',
        })
    },
    {
        value: EventTypesValues.INTERNAL_COMMUNICATIONS,
        label: intl.formatMessage({
            id: `oe.eventType.INTERNAL_COMMUNICATIONS`,
            description: 'Label text',
            defaultMessage: 'Internal Communications',
        })
    },
    {
        value: EventTypesValues.INVESTOR_CAPITAL_MARKETS_DAY,
        label: intl.formatMessage({
            id: `oe.eventType.INVESTOR_CAPITAL_MARKETS_DAY`,
            description: 'Label text',
            defaultMessage: 'Investor / Capital Markets Day',
        })
    },
    {
        value: EventTypesValues.NETWORKING_EVENT,
        label: intl.formatMessage({
            id: `oe.eventType.NETWORKING_EVENT`,
            description: 'Label text',
            defaultMessage: 'Networking Event',
        })
    },
    {
        value: EventTypesValues.NON_DEAL_ROADSHOW,
        label: intl.formatMessage({
            id: `oe.eventType.NON_DEAL_ROADSHOW`,
            description: 'Label text',
            defaultMessage: 'Non-Deal Roadshow',
        })
    },
    {
        value: EventTypesValues.OE_INTERNAL,
        label: intl.formatMessage({
            id: `oe.eventType.OE_INTERNAL`,
            description: 'Label text',
            defaultMessage: 'OE Internal',
        })
    },
    {
        value: EventTypesValues.ONSITE_HYBRID,
        label: intl.formatMessage({
            id: `oe.eventType.ONSITE_HYBRID`,
            description: 'Label text',
            defaultMessage: 'Onsite / Hybrid',
        })
    },
    {
        value: EventTypesValues.TRADE_SHOW,
        label: intl.formatMessage({
            id: `oe.eventType.TRADE_SHOW`,
            description: 'Label text',
            defaultMessage: 'Trade Show',
        })
    }
];

const eventLinks = (intl: IntlShape): IEventLinks[] => [
    {
        value: EventLinksValues.PASSPORT,
        label: intl.formatMessage(
            {
                id: `oe.titles.eventNavigation.passportTitle`,
                description: 'Passport title',
                defaultMessage: 'Passport',
            })
    },
];

const eventRegions = (intl: IntlShape): IEventRegions[] => [
    {
        value: EventRegionsValues.AMER,
        label: intl.formatMessage({
            id: `oe.eventRegion.amer`,
            description: 'Label text',
            defaultMessage: 'AMER',
        })
    }, {
        value: EventRegionsValues.APAC,
        label: intl.formatMessage({
            id: `oe.eventRegion.apac`,
            description: 'Label text',
            defaultMessage: 'APAC',
        })
    }, {
        value: EventRegionsValues.EMEA,
        label: intl.formatMessage({
            id: `oe.eventRegion.emea`,
            description: 'Label text',
            defaultMessage: 'EMEA',
        })
    }
];

const eventBusinessLines = (intl: IntlShape): IEventBusinessLines[] => [
    {
        value: EventBusinessLinesValues.OE_CONNECT,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.oeConnect`,
            description: 'Label text',
            defaultMessage: 'OE Connect',
        })
    }, {
        value: EventBusinessLinesValues.OE_CONFERENCE,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.oeConference`,
            description: 'Label text',
            defaultMessage: 'OE Conference',
        })
    }, {
        value: EventBusinessLinesValues.CAPITAL_MARKETS,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.capitalMarkets`,
            description: 'Label text',
            defaultMessage: 'Capital Markets',
        })
    },{
        value: EventBusinessLinesValues.CORPORATE_SERVICES,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.corporateServices`,
            description: 'Label text',
            defaultMessage: 'Corporate Services',
        })
    }, {
        value: EventBusinessLinesValues.CORPORATE_STREAMLINKS,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.corporateStreamLinks`,
            description: 'Label text',
            defaultMessage: 'Corporate StreamLinks',
        })
    }, {
        value: EventBusinessLinesValues.OE_STREAM,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.oeStream`,
            description: 'Label text',
            defaultMessage: 'OE Stream',
        })
    }, {
        value: EventBusinessLinesValues.PASSPORT,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.passport`,
            description: 'Label text',
            defaultMessage: 'Passport',
        })
    }, {
        value: EventBusinessLinesValues.OE_INTERNAL_TRAINING,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.oeInternalTraining`,
            description: 'Label text',
            defaultMessage: 'OE Internal Training',
        })
    }, {
        value: EventBusinessLinesValues.OETV,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.oetv`,
            description: 'Label text',
            defaultMessage: 'OETV',
        })
    }, {
        value: EventBusinessLinesValues.BUY_SIDE,
        label: intl.formatMessage({
            id: `oe.eventBusinessLine.buySide`,
            description: 'Label text',
            defaultMessage: 'Buy Side',
        })
    }
];

export { eventTypes, eventLinks, eventRegions, eventBusinessLines };
